import { render, staticRenderFns } from "./CImage.vue?vue&type=template&id=3a9dc86d&"
import script from "./CImage.vue?vue&type=script&lang=js&"
export * from "./CImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports